// Report catalog: categories and report IDs used by backend /reports/:reportType
export const REPORT_CATEGORIES = [
  {
    id: "inventory",
    title: "Inventory Reports",
    icon: "Inventory2",
    reports: [
      { id: "stock-summary", label: "Stock Summary Report" },
      { id: "stock-detailed", label: "Stock Detailed Report" },
      { id: "stock-movement", label: "Stock Movement Report" },
      { id: "batch-wise-stock", label: "Batch-wise Stock Report" },
      { id: "expiry-report", label: "Expiry Report" },
      { id: "low-stock", label: "Low Stock Report" },
      { id: "out-of-stock", label: "Out of Stock Report" },
      { id: "item-wise-profit", label: "Item-wise Profit Report" },
      { id: "warehouse-wise-stock", label: "Warehouse-wise Stock Report" },
      { id: "stock-valuation", label: "Stock Valuation Report" },
      { id: "negative-stock", label: "Negative Stock Report" },
      { id: "slow-fast-moving", label: "Slow Moving / Fast Moving Report" },
      { id: "stock-transfer", label: "Stock Transfer Summary" },
      { id: "stock-transfer-detailed", label: "Stock Transfer Detailed Report" },
      { id: "daily-stock-transfer", label: "Daily Stock Transfer Amounts Report" },
    ],
  },
  {
    id: "purchase",
    title: "Purchase Reports",
    icon: "ShoppingCart",
    reports: [
      { id: "purchase-summary", label: "Purchase Summary" },
      { id: "purchase-detailed", label: "Purchase Detailed" },
      { id: "supplier-wise-purchase", label: "Supplier-wise Purchase" },
      { id: "item-wise-purchase", label: "Item-wise Purchase Report" },
      { id: "purchase-item-detailed", label: "Item-wise Purchase Detailed" },
      { id: "purchase-return", label: "Purchase Return Report" },
      { id: "grn-report", label: "GRN Report" },
      { id: "pending-purchase-orders", label: "Pending Purchase Orders" },
      { id: "supplier-ledger", label: "Supplier Ledger" },
      { id: "input-vat", label: "Input VAT Report" },
      { id: "purchase-comparison", label: "Purchase Comparison Report" },
      { id: "credit-purchase", label: "Credit Purchases Report" },
    ],
  },
  {
    id: "sales",
    title: "Sales Reports",
    icon: "PointOfSale",
    reports: [
      { id: "sales-summary", label: "Sales Summary" },
      { id: "sales-detailed", label: "Sales Detailed" },
      { id: "sales-return", label: "Sales Return Report" },
      { id: "daily-sales", label: "Daily Sales Report (POS)" },
      { id: "item-wise-sales", label: "Item-wise Sales Report" },
      { id: "profit-report", label: "Profit Report" },
      { id: "bill-wise-profit", label: "Bill Wise Profit Report" },
      { id: "sales-by-salesperson", label: "Sales by Salesperson" },
      { id: "credit-sales", label: "Credit Sales Report" },
      { id: "output-vat", label: "Output VAT Report" },
      { id: "payment-collection", label: "Payment Collection Report" },
      { id: "discount-report", label: "Discount Report" },
    ],
  },
  {
    id: "management",
    title: "Management / Dashboard Reports",
    icon: "Dashboard",
    reports: [
      { id: "business-overview", label: "Business Overview Dashboard" },
      { id: "top-selling-products", label: "Top Selling Products" },
      { id: "top-suppliers", label: "Top Suppliers" },
      { id: "monthly-comparison", label: "Monthly Comparison Report" },
      { id: "yearly-growth", label: "Yearly Growth Report" },
    ],
  },
  {
    id: "compliance",
    title: "Important Reports (Mandatory for Compliance)",
    icon: "Gavel",
    reports: [
      { id: "input-vat-report", label: "Input VAT Report" },
      { id: "output-vat-report", label: "Output VAT Report" },
      { id: "vat-return-summary", label: "VAT Return Summary" },
      { id: "trn-invoice-report", label: "VAT-based Invoice Report" },
      { id: "tax-invoice-print", label: "Tax Invoice Print Format" },
    ],
  },
];

export const getReportById = (id) => {
  for (const cat of REPORT_CATEGORIES) {
    const r = cat.reports.find((x) => x.id === id);
    if (r) return { ...r, categoryId: cat.id, categoryTitle: cat.title };
  }
  return null;
};

export const getCategoryById = (id) =>
  REPORT_CATEGORIES.find((c) => c.id === id) || null;
